import { render, staticRenderFns } from "./ButtonLoadMore.vue?vue&type=template&id=241f1a8d&scoped=true&lang=pug&"
import script from "./ButtonLoadMore.vue?vue&type=script&lang=js&"
export * from "./ButtonLoadMore.vue?vue&type=script&lang=js&"
import style0 from "./ButtonLoadMore.vue?vue&type=style&index=0&id=241f1a8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241f1a8d",
  null
  
)

export default component.exports